import { useEffect, useRef, useState } from 'react'

import { TradingPoolTypeDto } from '@model/RewardsHubDashboardDto'

export const useTradingPoolProgress = (campaign: TradingPoolTypeDto) => {
  const percentage = (campaign.progressToNextEntry / campaign.lotsPerEntry) * 100
  const daysRemaining = useLiveCountdown(campaign.drawDate)
  return { percentage, daysRemaining }
}

export const useLiveCountdown = (date: string): string => {
  const [label, setLabel] = useState(() => getDaysRemaining(date))
  const intervalIdRef = useRef<number | null>(null)

  useEffect(() => {
    setLabel(getDaysRemaining(date))

    const tick = () => setLabel(getDaysRemaining(date))
    const msUntilNextMinute = 60000 - (Date.now() % 60000)

    const timeoutId = window.setTimeout(() => {
      tick()
      intervalIdRef.current = window.setInterval(tick, 60000)
    }, msUntilNextMinute)

    return () => {
      window.clearTimeout(timeoutId)
      if (intervalIdRef.current !== null) {
        clearInterval(intervalIdRef.current)
      }
    }
  }, [date])

  return label
}

export const getDaysRemaining = (date: string): string => {
  const msUntilDraw = new Date(date).getTime() - Date.now()

  if (msUntilDraw < 0) {
    return '-'
  }

  const minutes = Math.floor(msUntilDraw / (1000 * 60)) % 60
  const hours = Math.floor(msUntilDraw / (1000 * 60 * 60)) % 24
  const days = Math.floor(msUntilDraw / (1000 * 60 * 60 * 24))

  return `${days}d ${hours}h ${minutes}m`
}
